// src/context/AppVarsContext.js
import React, { createContext, useState, useEffect } from "react";

// Create the Context
export const AppVarsContext = createContext();

// Create the Provider Component
export const AppProvider = ({ children, appid }) => {
  const [appVars, setAppVars] = useState();
  const [appLoading, setLoading] = useState(true);

  // Fetch Application Variables
  const fetchAppVars = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({ appid });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const res = await fetch("https://api.digitalwerks.com/appVars", requestOptions);
      const response = await res.json();

      // Convert the response into a key-value object
      const keyValueObject = response.reduce((acc, item) => {
        acc[item.variable] = item.value;
        return acc;
      }, {});

      document.title = keyValueObject.application;
      setAppVars(keyValueObject);
    } catch (error) {
      console.error("Error fetching app variables:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (appid) {
      fetchAppVars();
    } else {
      console.error("No appid provided to AppProvider");
      setLoading(false);
    }
  }, [appid]);

  return (
    <AppVarsContext.Provider value={{ appVars, appLoading }}>
      {children}
    </AppVarsContext.Provider>
  );
};
